/**
 * @generated SignedSource<<0f25255f525a0d1dd41ab0b6d79ba9f3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespContentModuleSelector_itemSearch$data = {
  readonly browseContentModule: {
    readonly moduleType: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"SbRespContentModuleLanding_browseContentModule" | "SbRespContentModuleRegular_browseContentModule" | "SbSharedContentModuleBannerTiles_browseContentModule" | "SbSharedContentModuleBanner_browseContentModule" | "SbSharedContentModuleIconicDesign_browseContentModule" | "SbSharedContentModuleStorytellingHeader_browseContentModule">;
  } | null;
  readonly pageType: string | null;
  readonly seller: {
    readonly " $fragmentSpreads": FragmentRefs<"sellerBrandingHelpers_seller">;
  } | null;
  readonly " $fragmentType": "SbRespContentModuleSelector_itemSearch";
};
export type SbRespContentModuleSelector_itemSearch$key = {
  readonly " $data"?: SbRespContentModuleSelector_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespContentModuleSelector_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "contentModuleId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespContentModuleSelector_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pageType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "sellerBrandingHelpers_seller",
          "selections": [
            {
              "alias": "isRewarded",
              "args": [
                {
                  "kind": "Literal",
                  "name": "listNames",
                  "value": [
                    "SELLER_REWARDS_1",
                    "SELLER_REWARDS_2"
                  ]
                }
              ],
              "kind": "ScalarField",
              "name": "isAnchorListsMember",
              "storageKey": "isAnchorListsMember(listNames:[\"SELLER_REWARDS_1\",\"SELLER_REWARDS_2\"])"
            }
          ],
          "args": null,
          "argumentDefinitions": []
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "contentModuleId",
          "variableName": "contentModuleId"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "browseContentModule",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "moduleType",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbRespContentModuleRegular_browseContentModule"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbSharedContentModuleBanner_browseContentModule"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbSharedContentModuleIconicDesign_browseContentModule"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbSharedContentModuleBannerTiles_browseContentModule"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbRespContentModuleLanding_browseContentModule"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbSharedContentModuleStorytellingHeader_browseContentModule"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "20493382768d9b61cf73902b3b3b64af";

export default node;
